import { useState } from 'react';
import LabMeasurementReaderQuery from './LabMeasurementReaderQuery';
import LabMeasurementReaderResult from './LabMeasurementReaderResult';

function LabMeasurementReaderComponent(props) {
	const labMeasurementReaderName = props.labMeasurementReaderName || null;
	const [result, setResult] = useState(null);

	return (
		<div>
			<LabMeasurementReaderQuery onResult={_result => setResult(_result)} labMeasurementReaderName={labMeasurementReaderName} />
			{result != null && <LabMeasurementReaderResult result={result} onLoad={values => props.onLoad(values)} />}
		</div>
	);
}

export default LabMeasurementReaderComponent;